import { useEffect } from 'react';
import { Helmet } from 'react-helmet-async';
import useText from '@/hooks/useText';
import { HeroDiagram } from '@/components/AboutDISGENET/HeroDiagram';
import { FoundationsSection } from '@/components/AboutDISGENET/FoundationsSection';
import '@/components/AboutDISGENET/about-disgenet.css';

export default function AboutDISGENET() {
  const metaTitle = useText('about_disgenet.hero.title');
  const metaDescription = useText('about_disgenet.hero.description');

  useEffect(() => {
    const popovers = document.querySelectorAll('.popover');
    popovers.forEach(el => ((el as HTMLElement).style.display = 'none'));
  }, []);

  return (
    <>
      <Helmet>
        <title>DISGENET: {metaTitle}</title>
        <meta name="description" content={metaDescription} />
        <link rel="canonical" href="/about" />
        <meta name="twitter:card" content="summary_large_image" />
        <meta name="twitter:title" content={`DISGENET: ${metaTitle}`} />
        <meta name="twitter:description" content={metaDescription} />
        <meta property="og:type" content="website" />
        <meta property="og:url" content="https://www.disgenet.com/about" />
        <meta property="og:title" content={`DISGENET: ${metaTitle}`} />
        <meta property="og:description" content={metaDescription} />
      </Helmet>
      <main className="about-disgenet-page bg-white" role="main">
        <HeroDiagram />
        <FoundationsSection />
      </main>
    </>
  );
}
